'use strict';

import { environment } from './../environments/environment';

export const code = environment.code;

export const url_api = environment.url_api;